import { Injectable, Injector } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from "@angular/common/http";
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { AuthGuard } from "../guard/index";
import { environment } from "../../../environments/environment";
import { RefreshTokenService } from "../services/RefreshTokenService";
import { loginResult } from "../../model/loginResult";

const AUTHORIZE_URL = environment.apiUrl + "/api/login_check";
const REFRESH_URL = environment.apiUrl + "/api/token/refresh";

@Injectable()
  export class TokenInterceptor implements HttpInterceptor {

    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    
    constructor(private injector: Injector,private tokenService: RefreshTokenService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const authService = this.injector.get(AuthGuard);
      let req = request;
      if (authService.hasAuthorization() && req.url!==AUTHORIZE_URL && req.url!==REFRESH_URL) {
        req = request.clone({
          headers: request.headers.set('Authorization', authService.getHeaderAuthorization(""))
          //headers: request.headers.set('ApiAuth', authService.getHeaderAuthorization(""))
        });
      }

      return next.handle(req).catch
          (
             (error:any)=>
             {
               
                if (error instanceof HttpErrorResponse) {
                  if (error.url!==AUTHORIZE_URL && (error.status === 401) ) {              
                    return this.handle401Error(req,next);
                  }
                  else{
                    return Observable.throw(error);
                  }
                }
                else
                {
                  return Observable.throw(error);
                }             
            }); 
          
/*
      return next.handle(req).do(
        () => {},
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {              
              return this.handle401Error(req,next);
            }
          }
        });*/
    }

    addToken(req: HttpRequest<any>, token:string): HttpRequest<any> {
      const authService = this.injector.get(AuthGuard);
      return req.clone({
        headers: req.headers.set('Authorization', authService.getHeaderAuthorization(token))
        //headers: req.headers.set('ApiAuth', authService.getHeaderAuthorization(token))
      });
    }

    private handle401Error(req, next)
    {
      const authService = this.injector.get(AuthGuard);

      if(req.url == REFRESH_URL )
      {
          authService.clearAuthToken();
          this.tokenService.processing = false;
          return new Observable();
      }

      if (!this.tokenService.processing && req.url !== AUTHORIZE_URL) {
        this.tokenService.processing = true;

        // Reset here so that the following requests wait until the token
        // comes back from the refreshToken call.
        this.tokenSubject.next(null);
               
        return authService.refreshToken()
            .switchMap((newToken: loginResult) => {
                
                if (newToken && newToken.token) {
                    this.tokenSubject.next(newToken.token);                    
                    authService.updateToken(newToken.token,newToken.refresh_token);
                    
                    return next.handle(this.addToken(req, newToken.token));
                }

                // If we don't get a new token, we are in trouble so logout.
                authService.clearAuthToken();
                return new Observable();
            })
            .catch(error => {              
                // If there is an exception calling 'refreshToken', bad news so logout.
                authService.clearAuthToken();
                return new Observable();
            })
            .finally(() => {
                this.tokenService.processing = false;
            });
    } else {
        return this.tokenSubject
            .filter(token => token != null)
            .take(1)
            .switchMap(token => {
                return next.handle(this.addToken(req, token));
            });
    }
  }
    

  }


// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/interceptors/TokenInterceptor.ts